/**
 * Converts stored color pixel values to display pixel values using a LUT.
 *
 * Note: Skips alpha value for any input image pixel data.
 *
 * @param {Image} image A  Image Object
 * @param {Array} lut Lookup table array
 * @param {Uint8ClampedArray} canvasImageDataData canvasImageData.data buffer filled with white pixels
 *
 * @returns {void}
 * @memberof Internal
 */
export default function (image, lut, canvasImageDataData) {
  //const pixelData = image.getPixelData();
  const pixelData = image.pixelData;

  //const minPixelValue = image.minPixelValue;
  const minPixelValue = image.minMax[0];
  let canvasImageDataIndex = 0;
  let storedPixelDataIndex = 0;
  const numPixels = pixelData.length;

  let moveStoredPixelIndex = image.aligned ? 2 : 1;

  // NOTE: As of Nov 2014, most javascript engines have lower performance when indexing negative indexes.
  // We have a special code path for this case that improves performance.  Thanks to @jpambrun for this enhancement
  if (minPixelValue < 0) {
    while (storedPixelDataIndex < numPixels) {
      canvasImageDataData[canvasImageDataIndex++] =
        lut[pixelData[storedPixelDataIndex++] + -minPixelValue]; // Red
      canvasImageDataData[canvasImageDataIndex++] =
        lut[pixelData[storedPixelDataIndex++] + -minPixelValue]; // Green
      canvasImageDataData[canvasImageDataIndex] =
        lut[pixelData[storedPixelDataIndex] + -minPixelValue]; // Blue
      // storedPixelDataIndex += 2;
      // canvasImageDataIndex += 2;
      //storedPixelDataIndex += 1;
      storedPixelDataIndex += moveStoredPixelIndex;
      canvasImageDataIndex += 2;
    }
  } else {
    while (storedPixelDataIndex < numPixels) {
      canvasImageDataData[canvasImageDataIndex++] =
        lut[pixelData[storedPixelDataIndex++]]; // Red
      canvasImageDataData[canvasImageDataIndex++] =
        lut[pixelData[storedPixelDataIndex++]]; // Green
      canvasImageDataData[canvasImageDataIndex] =
        lut[pixelData[storedPixelDataIndex]]; // Blue
      // storedPixelDataIndex += 2;
      // canvasImageDataIndex += 2;
      //storedPixelDataIndex += 1;
      storedPixelDataIndex += moveStoredPixelIndex;
      canvasImageDataIndex += 2;
    }
  }
}
